module.exports = __webpack_public_path__ + "img/collection-weddingRingsFacetes@2x.ad3e440.jpg";